'use strict';
(() => {
  const section = document.getElementById('story');
  if (!section) return;
  const chapters = [...section.querySelectorAll('.story-chapter')];
  const links = [...section.querySelectorAll('.story-chapter-link')];
  const pagination = section.querySelector('.story-pagination');
  const progress = section.querySelector('.story-progress');
  const previous = section.querySelector('.story-back');
  const next = section.querySelector('.story-next');
  if (!chapters.length || links.length !== chapters.length) return;
  const contents = section.querySelector('.story-contents');
  const contentsToggle = section.querySelector('.story-toc-toggle');
  const contentsCount = section.querySelector('.story-toc-count');
  contentsToggle.hidden = false;
  function closeContents() {
    contents.classList.remove('is-open');
    contentsToggle.setAttribute('aria-expanded', 'false');
  }
  contentsToggle.addEventListener('click', () => {
    const open = contents.classList.toggle('is-open');
    contentsToggle.setAttribute('aria-expanded', String(open));
  });
  let current = 0;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const chapterFromHash = () => chapters.findIndex(chapter => `#${chapter.id}` === location.hash);

  function showChapter(index, { navigate = false, focus = false, scroll = false } = {}) {
    current = Math.max(0, Math.min(chapters.length - 1, index));
    chapters.forEach((chapter, i) => { chapter.hidden = i !== current; });
    links.forEach((link, i) => {
      if (i === current) link.setAttribute('aria-current', 'step');
      else link.removeAttribute('aria-current');
    });
    progress.textContent = `Chapter ${current + 1} of ${chapters.length}`;
    contentsCount.textContent = `${current + 1} / ${chapters.length}`;
    previous.disabled = current === 0;
    const isLast = current === chapters.length - 1;
    next.textContent = isLast ? 'Back to the beginning ↗' : 'Next chapter →';
    const nextTitle = chapters[isLast ? 0 : current + 1].querySelector('h3').textContent;
    next.setAttribute('aria-label', `${isLast ? 'Return to' : 'Next chapter:'} ${nextTitle}`);
    if (navigate && location.hash !== `#${chapters[current].id}`) {
      history.pushState(null, '', `#${chapters[current].id}`);
    }
    if (navigate) closeContents();
    if (focus) chapters[current].querySelector('h3').focus({ preventScroll: true });
    if (scroll) chapters[current].scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  }

  links.forEach((link, i) => link.addEventListener('click', event => {
    // Preserve native new-tab and modified-click behavior for chapter links.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    showChapter(i, { navigate: true, focus: true, scroll: true });
  }));
  previous.addEventListener('click', () => showChapter(current - 1, { navigate: true, focus: true, scroll: true }));
  next.addEventListener('click', () => showChapter((current + 1) % chapters.length, { navigate: true, focus: true, scroll: true }));
  function restoreChapter() {
    const index = chapterFromHash();
    if (index >= 0) showChapter(index, { scroll: true });
  }
  window.addEventListener('hashchange', restoreChapter);
  window.addEventListener('popstate', restoreChapter);
  pagination.hidden = false;
  section.classList.add('story-enhanced');
  const initial = chapterFromHash();
  showChapter(initial >= 0 ? initial : 0);
  if (initial >= 0) requestAnimationFrame(() => chapters[initial].scrollIntoView({ block: 'start', behavior: 'instant' }));
})();
